import { Container, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface ContentContainerProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const ContentContainer = ({ children, sx }: ContentContainerProps) => (
  <Container sx={sx}>{children}</Container>
);
